/**
 * @module common/errors/invalid-full-name
 */

/**
 * @extends Error
 * @classdesc Ошибка не указанного имени
 */
class InvalidFullNameError extends Error {
  constructor(
    message = 'Некорректно указано полное имя',
    filename,
    lineNumber,
  ) {
    super(message, filename, lineNumber);
  }
}

export default InvalidFullNameError;
